import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  selectAll,
  selectEntities,
  State,
} from './lib/patient-workflow/patient-workflow.reducer';

export * from './lib/patient-workflow-api/patient-workflow-api.actions';
export * from './lib/patient-workflow-api/patient-workflow-api.service';
export * from './lib/patient-workflow-ws/patient-workflow-ws.actions';
export * from './lib/patient-workflow/patient-workflow.actions';
export * from './lib/patient-workflow/patient-workflow.model';
export * from './lib/shared-patient-workflow-data-access.module';

export const getState = createFeatureSelector<State>('patientWorkflow');

export const getPatientWorkflows = createSelector(getState, selectAll);

export const getPatientWorkflowEntities = createSelector(getState, selectEntities);
